import { ref } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useValidJustif(props, {emit}) {
    const locale = ref('fr-FR');
    const idJustification = ref('');
    const justificationText = ref('');
    const type = ref('');
    const validJustification = ref('');
    const justificationData = ref({});
    const showJustification = ref(true);

    const toastMessage = ref('');
    const showNotification = ref(false);
    const toastType = ref('info');
    const duration = ref(5000);

    const insertJustification = async () => {
        justificationData.value = {
            idJustification: idJustification.value,
            type: type.value,
            justificationText: justificationText.value,
            idLigneAnomalie: props.idAnomalie,
            validJustification: validJustification.value,
        };

        try {
            const data = await http.insertJustification(justificationData.value);
            idJustification.value = data;

            eventBus.emit('reloadAnomaliesToJustif');
            eventBus.emit('reloadRequete');
            eventBus.emit('reloadRapport');
            emit('close');

            emit('notification', {
                showNotification: true,
                toastMessage: 'La justification a bien été validée',
                toastType: 'success',
            });
        } catch (error) {
            console.error("Erreur lors de l'insertion de la justification", error);
        }
    };

    return {
        locale,
        idJustification,
        justificationText,
        type,
        validJustification,
        showJustification,
        insertJustification,
        toastMessage,
        showNotification,
        toastType,
        duration,
    };
}